export default {
  titre: "Diabète Québec",
  soustitre: "Sous-titre",
  collecte: {
    listeobjectifs: "Participants",
    rechercher: "Rechercher un participant",
    retourAuxObjectifs: "Retour à la liste des participants",
    contribuez: "Contribuez",
    commentaireTitre: "Écrivez un message d’encouragement (facultatif)",
    commentaireLabel: "Message",
    commentaireAnonymeLabel: "Je souhaite que mon message demeure anonyme",
    montantDonMasqueLabel: "Je souhaite que le montant de mon don soit masqué",
    anonyme: "Anonyme",
    participants: "Derniers messages d'encouragement",
    voirTousLesMessages: "Voir tous les messages",
    aucunMessage: "Aucun message. Soyez le premier !",
    voirLesDerniersMessages: ({ named }) => `Voir les ${named("n")} derniers messages`,
    de: " de ",
  },
  objectifCard: {
    faireundon: "Faire un don",
    premierparticipant: "Soyez le premier à participer",
    participant: "participant",
    participants: "participants",
  },
  infosPersonnelles: {
    courriel: "Courriel",
    prenom: "Prénom",
    nom: "Nom",
    anneeNaissance: "Année de naissance",
    civilite: "Civilité",
  },
  adresse: {
    adresse: "Adresse",
    ville: "Ville",
    codePostal: "Code postal",
    province: "Province",
    telephone: "Téléphone",
    telephoneAuTravail: "Téléphone au travail",
  },
  dedicace: {
    prenom: "Prénom",
    nom: "Nom",
    adresse: "Adresse de la famille",
    ville: "Ville",
    codePostal: "Code postal",
    province: "Province",
    famille: "Famille",
    consentementHonoriam: "J’accepte que mes coordonnées soient transmises à la personne honorée",
    consentementMemoriam: "J’accepte que mes coordonnées soient transmises à la famille de la personne décédée",
  },
  formulaireDon: {
    donEnLigne: "Don en ligne",
    donInMemoriam: "Don In Memoriam",
    donInHonoriam: "Don In Honoriam",
    memoireDe: "À la mémoire de...",
    occasionDe: "À l'occasion de...",
    contribution: "Contribution",
    unique: "Unique",
    mensuel: "Mensuel",
    detailPrelevement: "* prélèvement le 1er jour du mois",
    autre: "Autre",
    montant: "Montant",
    source: "J’ai entendu parler de Diabète Québec par",
    donateur: "Donateur.rice",
    donCorporatif: "Don corporatif",
    societe: "Société",
    adresse: "Adresse",
    boutonPaiement: "Passer au paiement",
    numeroFondation: "Numéro d'entreprise : 13321 4601 RR0001",
    remerciementTitre: "Merci !",
    remerciementParagraphe:
      "<p>Nous avons bien reçu votre don.</p><p>Nous vous remercions sincèrement de votre soutien car chaque dollar compte et peut faire toute la différence.</p><p>Un courriel vient de vous être envoyé dans lequel vous trouverez votre reçu d'impôt.</p>",
    remerciementParagrapheMensuel:
      "<p>Nous avons bien reçu votre inscription au programme de dons mensuels Créateurs d’espoir et vous remercions sincèrement de votre soutien.</p><p>Votre don sera prélevé le 1er de chaque mois sur votre carte de crédit.  À noter que vous ne recevrez qu’un seul reçu aux fins de l’impôt, et ce à la fin de l’année.</p><p>Vous pouvez mettre fin à cette entente en tout temps en communiquant avec notre service aux membres et donateurs au 514-259-3422, poste 227 / 1-800-361-3504, poste 227.</p>",
    retourObjectif: "Retour à la page du participant",
    retourEvenement: "Retour à la page de l'événement",
  },
  formulaireAuth: {
    sousTitre: "Si vous êtes membre indiquez votre numéro ainsi que votre code postal afin de vous identifier.",
    numero: "Numéro",
    codePostal: "Code Postal",
    seConnecter: "Se connecter",
    seDeconnecter: "Se déconnecter",
    connexion: "Connexion",
    unauthorizedMessage:
      "Votre identifiant et votre code postal ne sont pas reconnus. Assurez-vous de mettre un numéro à 6 chiffres.",
  },
  locales: {
    fr: "Français",
    en: "English",
  },
  rules: {
    champObligatoire: "Ce champ est obligatoire",
    codePostalNonValide: "Code postal non-valide",
    telephoneNonValide: "Téléphone non-valide",
    courrielNonValide: "Courriel non-valide",
    messageTropLong: "Longueur du message maximum de 300 caractères.",
    erreurCodePromo: "Code promotionnel inexistant ou incorrect",
  },
  boutique: {
    titre: "Boutique en ligne",
    retourALaBoutique: "Retour à la boutique",
    viderLePanier: "Vider le panier",
    contenuDuPanier: "Contenu du panier",
    payer: "Payer",
    finaliser: "Finaliser la commande",
    retourALaListeDesProduits: "Retour à la liste des produits",
    dejaMembre: "Si vous êtes déjà membre utiliser le bouton CONNEXION en haut à droite de la page.",
    ajouterAuPanier: "Ajouter au panier",
    tableauProduits: {
      titre: "Titre",
      categorie: "Catégorie",
      langue: "Langue",
      prix: "Prix",
    },
    voirPlus: "Voir plus...",
    panier: {
      ajouter: "Ajouter un",
      retirer: "Retirer",
      fraisPoste: "Frais de poste",
      fraisSup: "Frais additionnel",
      tps: "TPS",
      tvq: "TVQ",
      total: "Total",
      panierVide: "Panier vide",
    },
    passerALaCaisse: "Passer à la caisse",
    adresseLivraison: "Adresse de livraison",
    rechercherUnProduit: "Rechercher un produit...",
    toutesLesCategories: "Toutes",
    toutesLesLangues: "Toutes",
    produits: "Produits",
    affichage: "Affichage",
    modePaiement: "Mode de paiement",
    messageError: "Une erreur est survenue lors de la commande, merci de rééssayer.",
    messageSucces: "La commande est validée. Merci. Voici votre numéro de commande : ",
  },
  chargement: "Chargement...",
  formulaireAdhesion: {
    professionnelDeLaSante: {
      titre: "Formulaire adhésion - Professionnel de la Santé",
      lien: "Professionnel de la Santé",
      agreementSharing:
        "Acceptez-vous que Diabète Québec partage vos coordonnées personnelles avec son entité de formation Universi-D ?",
      profession: "Profession",
      license: "Numéro ordre professionnel",
    },
    personneVivantAvecLeDiabete: {
      titre: "Formulaire adhésion - Personne touchée par le diabète",
      lien: "Personne touchée par le diabète",
    },
    informationsPersonnelles: "Informations personnelles",
    adresse: "Adresse personnelle",
    desireFaireUnDon: "Je désire faire un don en plus de payer ma cotisation annuelle",
    typeAdhesion: "Je désire devenir membre de Diabète Québec et recevoir gratuitement la revue DIA·LOGUE.",
    versionPleinSoleil: "Je désire recevoir DIA·LOGUE en version:",
    boutonPaiement: "Confirmer l'adhésion",
    remerciementTitre: "Bienvenue chez Diabète Québec !",
    remerciementParagraphe: "<p>Votre demande d'abonnement a été reçue.</p>",
    codePromo: "Appliquer un code promotionnel",
    codePromoLabel: "Code promotionnel",
    boutonCheckCodePromo: "Appliquer",
    source: "J’ai entendu parler de Diabète Québec par",
  },
  transactionRealisee: "<p>Transaction réalisée avec succès.</p>",
  paysafe: {
    buttonLabel: "Confirmer",
    locale: "fr_CA",
    companyName: "Diabète Québec",
  },
  revuesPleinSoleil: {
    searchLabel: "Rechercher / Filtrer",
    titreRevue: "Titre",
    dateParution: "Date parution",
    urlModeFlip: "Lien de visualisation mode FlipBook",
    urlModePdf: "Lien de visualisation mode PDF",
  },
  erreur: {
    paiement: {
      titre: "Une erreur est survenue lors de votre paiement.",
      description:
        "Veuillez communiquez avec nous pour plus d'informations ou pour procéder à votre don par téléphone.",
      telephone: "514-259-3422 poste 227 / 1-800-361-3504  poste 227",
    },
    collecte: {
      titre: "Une erreur est survenue lors du chargement de l'événement ou celui n'est plus disponible.",
      description: "Veuillez communiquez avec nous pour plus d'informations.",
      telephone: "514-259-3422 poste 227 / 1-800-361-3504  poste 227",
    },
  },
  avertissements: {
    redirectionDepuisEspaceMembre:
      "<p>Veuillez noter que nous apportons présentement des modifications à l’Espace des membres.  Vous avez été redirigé vers une nouvelle page afin de procéder à votre renouvellement, faire un don ou accéder à la boutique. Merci de votre compréhension.</p><p>L’Équipe de Diabète Québec</p>",
  },
}
